// ENG-3340: helpers for the `failed_fax_visibility` feature. The server sends
// `fax_retry_count`, `resend_blocked` and `fax_resend_available` only for
// organizations with the feature, so absent fields keep every surface unchanged.
export const MAX_AUTOMATIC_FAX_RETRIES = 5;

const FAILED_FAX_STATUSES = ['failure', 'partialsuccess'];

// "Retrying (n/5)" while an automatic retry is running, else null.
export const retryingLabel = (data) => {
  const retryCount = data && data.fax_status === 'inprogress' ? Number(data.fax_retry_count) : 0;
  if (!retryCount) return null;
  return `Retrying (${Math.min(retryCount, MAX_AUTOMATIC_FAX_RETRIES)}/${MAX_AUTOMATIC_FAX_RETRIES})`;
};

// The status page offers Resend for a failed fax the selected organization owns.
export const canResendFromStatus = (data, patient) => Boolean(
  data
  && !patient
  && data.fax_resend_available === true
  && data.is_ata_fax !== true
  // ENG-3679: a resent fax is settled; its newer fax is the one to resend.
  && data.resent !== true
  && FAILED_FAX_STATUSES.includes(data.fax_status),
);

// Shown on a disabled Resend while the server still blocks it (in progress or
// rescheduled after a rate limit).
export const RESEND_BLOCKED_HINT = 'This fax is still being sent. Try again later.';

// Opens the existing resend dialog for the fax on a status page, behind the same
// `resend_records` permission the Sent page checks.
// `onResent(sendToken)` lets an opener other than the full status page (the Sent
// status drawer) refresh itself; without it the modal reloads the status page.
export const openStatusPageResend = async ({
  data, fileToken, openModal, verifyFeatureAccess, captureAnalytics, onResent,
}) => {
  const canResend = await verifyFeatureAccess('resend_records');
  if (!canResend) return openModal({ type: 'RAISE_FLAG', featureFlag: 'resend_records' });
  captureAnalytics('failed_fax_resend_clicked', { source: 'status_page' });
  return openModal({
    type: 'RESEND_RECORD',
    data: {
      source: 'status',
      recipient: {
        file_token: fileToken,
        send_token: data.send_token,
        receiver_fax: data.receiver,
        receiver_name: data.receiver_name,
      },
      ...(onResent ? { onResent } : {}),
    },
  });
};
